module.exports = __webpack_public_path__ + "media/images/logo_aldo-250837805c89ae8449920ac6bd31b5d7.png";